<div
	class="modal fade"
	id="passwordUpdatedModal"
	tabindex="-1"
	aria-labelledby="passwordUpdatedModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog">
		<div class="modal-content">
			<div
				class="modal-header"
				style="display: flex; align-items: center; justify-content: center; background-color: #c5deff"
			>
				<p
					class="modal-title"
					id="passwordUpdatedModalLabel"
				>
					<strong>Password Aggiornata</strong>
				</p>
			</div>
			<div
				class="modal-body"
				style="margin-top: 25px; margin-bottom: 25px"
			>
				La tua password è stata aggiornata con successo.
			</div>
		</div>
	</div>
</div>

<div
	class="modal fade"
	id="logoutSuccess"
	tabindex="-1"
	aria-labelledby="logoutSuccessLabel"
	aria-hidden="true"
>
	<div class="modal-dialog">
		<div class="modal-content">
			<div
				class="modal-header justify-content-center"
				style="background-color: #c5deff"
			>
				<h5
					class="modal-title"
					id="logoutSuccessLabel"
				>
					<strong>Logout effettuato</strong>
				</h5>
			</div>

			<div
				class="modal-body text-center"
				style="margin: 25px 0"
			>
				Hai effettuato il logout con successo. A presto!
			</div>
		</div>
	</div>
</div>

<div
	class="modal fade"
	id="sendEmail"
	tabindex="-1"
	aria-labelledby="logoutSuccessLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-centered modal-lg">
		<div class="modal-content">
			<div class="modal-header justify-content-center">
				<h5
					class="modal-title w-100 text-center"
					id="logoutSuccessLabel"
				>
					<strong>Sessione scaduta</strong>
				</h5>
				<button
					type="button"
					class="btn-close"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<!-- Colonna sinistra: immagine -->
					<div class="col-md-6 d-flex align-items-center justify-content-center">
						<img
							src="image/logo-homaiLogin.png"
							alt="HomAI Logo"
							class="img-fluid"
							style="max-width: 80%"
						/>
					</div>

					<!-- Colonna destra: testo + input -->
					<div class="col-md-6 d-flex flex-column justify-content-center px-4">
						<p>Inserisci nuovamente la tua email per confermare l'account e iniziare subito</p>
						<div class="mb-3 text-start">
							<label
								for="email"
								class="form-label"
								>Email</label
							>
							<input
								type="email"
								class="form-control"
								id="email"
								placeholder="Inserisci la tua email"
								[(ngModel)]="email"
								name="email"
								required
								email
								#emailInput="ngModel"
							/>

							@if (emailInput.invalid && emailInput.touched) {
								<div
									class="invalid-feedback d-block"
									style="margin-left: 13px"
								>
									@if (emailInput.errors?.['required']) {
										<div>La email è obbligatoria.</div>
									}
									@if (emailInput.errors?.['email']) {
										<div>Inserisci un indirizzo email valido.</div>
									}
								</div>
							}
							<!-- Validazione opzionale -->
							<!-- <div *ngIf="emailInput.invalid && emailInput.touched" class="invalid-feedback d-block" style="margin-left: 13px;">
                La email è obbligatoria.
              </div> -->
							<div style="display: flex; width: 100%; justify-content: flex-end">
								<button
									(click)="submit()"
									[disabled]="emailInput.invalid"
									type="submit"
									class="btn btn-primary btn-center-rounded mt-3"
								>
									Invia istruzioni
								</button>
							</div>
              @if(emailInviataConSuccesso){
                <div
                class="  alert alert-success"
                role="alert"
                style="margin-top: 10px"
              >
              <strong>Info:</strong> Ti abbiamo inviato un'email. Aprila per confermare il tuo account e continuare.
              </div>
              }@if(erroreInvioEmail){
                <div
                class="alert alert-danger"
                role="alert"
                style="margin-top: 10px"
              >
                <strong>ERRORE:</strong> {{ errors.errorMessage }}
              </div>
              }
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
